function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import _ from "lodash";
import { Table, Button } from "react-bootstrap";

var ButtonInputTable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ButtonInputTable, _React$Component);

  function ButtonInputTable() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      checkbox: true
    });

    _defineProperty(_assertThisInitialized(_this), "handleButtonClick", function (rowData, colData, currentValue) {
      var onChange = _this.props.onChange;
      return function () {
        var newData = {
          row: rowData,
          column: colData,
          value: currentValue
        };
        onChange && onChange(newData);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "isCellValueChecked", function (rowData, colData, optionCellValue) {
      var formData = _this.props.formData;
      return optionCellValue === formData.value && rowData === formData.row && colData === formData.column;
    });

    return _this;
  }

  var _proto = ButtonInputTable.prototype;

  _proto.renderCell = function renderCell(rowData, colData, rowIndex, colIndex) {
    var optionValueMatrix = _.get(this.props, "uiSchema.ui:options.values", []);

    var optionCellValue = _.get(optionValueMatrix, rowIndex + "." + colIndex, null);

    var isSelected = this.isCellValueChecked(rowData, colData, optionCellValue);
    return optionCellValue ? /*#__PURE__*/React.createElement(Button, {
      as: "span",
      className: "buttonCell",
      variant: isSelected ? "secondary" : "outlined",
      active: isSelected,
      onClick: this.handleButtonClick(rowData, colData, optionCellValue)
    }, optionCellValue) : "";
  };

  _proto.render = function render() {
    var _this2 = this;

    var _$get = _.get(this.props, "uiSchema.ui:options", {}),
        rows = _$get.rows,
        columns = _$get.columns;

    return /*#__PURE__*/React.createElement(Table, {
      responsive: true
    }, /*#__PURE__*/React.createElement("tbody", null, _.map(rows, function (rowData, rowIndex) {
      return /*#__PURE__*/React.createElement("tr", {
        key: rowIndex,
        className: "input_table_row input_table_row-" + rowIndex
      }, /*#__PURE__*/React.createElement("td", {
        className: "headerCell"
      }, /*#__PURE__*/React.createElement("b", null, rowData)), _.map(columns, function (colData, colIndex) {
        return /*#__PURE__*/React.createElement("td", {
          key: colIndex,
          className: "input_table_cell input_table_cell_" + rowIndex + "-" + colIndex
        }, _this2.renderCell(rowData, colData, rowIndex, colIndex));
      }));
    }), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), _.map(columns, function (colData, colIndex) {
      return /*#__PURE__*/React.createElement("th", {
        key: colIndex
      }, colData);
    }))));
  };

  return ButtonInputTable;
}(React.Component);

export default ButtonInputTable;